import {VanillaVoidCallback} from '../VanillaReader/VanillaReaderModel';

/**
 * # VanillaReaderUiGuidedReadingContentMask
 *
 * ## RESPONSIBILITIES
 *
 * A floating action button that is shown when ever the guided reading mode is active.
 * The button lets the user toggle the masking layer on and off.
 *
 * ## RELATED TYPES
 * - VanillaReaderUiGuidedReadingContentMask
 *
 */
export class VanillaReaderUiFabPanelMaskToggle {
    private _template = `<button class="vanilla-reader__fab" id="vanilla-reader__fab-mask-toggle" type="button" title="Toggle Guided Reading mask overlay" aria-hidden="true"><span class="vanilla-reader__fab__icon" id="vanilla-reader__fab-mask-toggle__icon" aria-hidden="true">crop</span></button>`;
    private _onClickCallback: VanillaVoidCallback | undefined;
    private _onVisibleCallback: VanillaVoidCallback | undefined;
    private _onHiddenCallback: VanillaVoidCallback | undefined;
    private _toggleButton: HTMLButtonElement;
    private _toggleButtonIcon: HTMLElement;
    private _isActive: boolean = false;

    constructor(private _hostElement: HTMLElement, insertPosition: InsertPosition = 'afterbegin') {
        this._hostElement.insertAdjacentHTML(insertPosition, this._template);
        this._toggleButton = this._hostElement.querySelector('#vanilla-reader__fab-mask-toggle')!;
        this._toggleButtonIcon = this._hostElement.querySelector('#vanilla-reader__fab-mask-toggle__icon')!;

        this._toggleButton.addEventListener('click', (ev: MouseEvent) => {
            ev.preventDefault();
            ev.stopImmediatePropagation();
            if (this._onClickCallback) {
                if (this.isVisible) {
                    this._isActive = !this._isActive;
                    let icon: string = this._isActive ? 'fullscreen' : 'crop';
                    this._toggleButtonIcon.innerText =icon;

                    this._onClickCallback();
                }
            }
        });
    }

    public get isVisible(): boolean {
        return !this._toggleButton.hasAttribute('aria-hidden');
    }

    show(): void {
        this._toggleButton.removeAttribute('aria-hidden');
        this._toggleButton.style.display = 'flex';
        this._toggleButton.style.opacity = '1';
        this._toggleButton.style.pointerEvents = 'all';
        if (this._onVisibleCallback) {
            this._onVisibleCallback();
        }
    }

    hide(): void {
        this._toggleButton.setAttribute('aria-hidden', 'true');
        this._toggleButton.style.opacity = '0';
        this._toggleButton.style.pointerEvents = 'none';

        setTimeout(()=>{
            this._toggleButton.style.display = 'none';
        },200);

        if (this._onHiddenCallback) {
            this._onHiddenCallback();
        }
    }

    getComponentElement(): HTMLElement {
        return this._toggleButton;
    }

    onClick(callback: VanillaVoidCallback): void {
        this._onClickCallback = callback;
    }

    onVisible(callback: VanillaVoidCallback): void {
        this._onVisibleCallback = callback;
    }

    onHidden(callback: VanillaVoidCallback): void {
        this._onHiddenCallback = callback;
    }

}
